<!-- 由 suu 创建于 2025-10-23 星期四 -->
<!-- 已上课18及以上超练弹窗-->
<template>
  <div
    class="DetailExceedTips"
    v-if="tipsInfo && tipsInfo.risk_setting && tipsInfo.risk_setting.head"
  >
    <van-action-sheet
      v-model="showActionSheet"
      @closed="closeActionSheet"
      :safe-area-inset-bottom="false"
    >
      <div
        class="action-sheet-content"
        :class="{
          'action-sheet-content-app': isApp,
          'action-sheet-content-red': tipsInfo.over_count >= redNum
        }"
      >
        <!-- 上方 -->
        <div class="asc-top-bg-box" @click.stop="">
          <!-- <div class="asc-title">训练风险提示</div> -->
          <div class="asc-text-head" v-html="tipsInfo.risk_setting.head"></div>
        </div>
        <!-- 上边距25px透明 点击可关闭弹窗区域 -->
        <div class="asc-top-mask" @click="handleActionSheetClick"></div>
        <!-- 感叹号 -->
        <img
          class="asc-gt"
          :src="gtImg"
          @click="handleActionSheetClick"
          alt=""
        />
        <!-- 头部底图 -->
        <img
          class="asc-top-bg"
          :src="'https://cdnvue.gymcity.com.cn/uploads/exceed-tips-top-bg'"
          alt=""
          @click="handleActionSheetClick"
        />
        <!-- 中间内容 -->
        <div class="asc-content" @click.stop="">
          <div
            class="asc-content-A"
            v-if="tipsInfo.risk_setting.A"
            v-html="tipsInfo.risk_setting.A"
          ></div>
          <div class="asc-content-B" v-if="tipsInfo.risk_setting.B">
            <div
              class="asc-content-B-row"
              v-for="(item, index) in tipsInfo.risk_setting.B.split('<br/>')"
              :key="index"
            >
              <div
                class="asc-content-B-item"
                v-for="(text, ti) in item.split('')"
                v-html="text"
                :key="ti"
              ></div>
            </div>
          </div>
          <div
            class="asc-content-C"
            v-if="tipsInfo.risk_setting.C"
            v-html="tipsInfo.risk_setting.C"
          ></div>
          <div
            class="asc-content-D"
            v-if="tipsInfo.risk_setting.D"
            v-html="tipsInfo.risk_setting.D"
          ></div>
          <div class="asc-content-E" v-if="tipsInfo.risk_setting.E">
            <div class="e-title" v-html="tipsInfo.risk_setting.E"></div>
            <div class="e-item" v-for="item in eText" :key="item">
              <van-icon class="e-item-icon" name="checked" color="#24C789" />
              <div class="e-item-text">{{ item }}</div>
            </div>
          </div>
        </div>
        <!-- 底部按钮 -->
        <div class="asc-bottom-btn-wrap" @click.stop="">
          <div
            class="asc-bottom-btn user-btn"
            :class="{
              'btn-countdown-active': countdown <= 0
            }"
            @click.stop="handleBtnClick"
          >
            <div class="btn-text">同意并预约</div>
            <div class="btn-countdown" v-if="countdown > 0">
              {{ countdown }}s
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { ActionSheet } from 'vant'
export default {
  name: 'DetailExceedTips',

  components: {
    [ActionSheet.name]: ActionSheet
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    tipsInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      eText: [
        '我确认自身状态适宜训练',
        '我自愿承担可能发生的损伤风险',
        '我免除场馆及教练因我此次选择带来的相关责任'
      ],
      showActionSheet: this.show,
      countdown: 4,
      timer: null,
      redNum: 22
    }
  },

  computed: {
    isApp() {
      // return true;
      return this.$betterwe.isApp()
    },
    gtImg() {
      return this.tipsInfo.over_count < this.redNum
        ? 'https://cdnvue.gymcity.com.cn/uploads/exceed-tips-gt-18'
        : 'https://cdnvue.gymcity.com.cn/uploads/exceed-tips-gt-21'
    }
  },

  watch: {
    show(newVal) {
      this.showActionSheet = newVal
      if (newVal) {
        this.startCountdown()
      }
    }
  },

  created() {},

  mounted() {},

  destroyed() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },

  methods: {
    startCountdown() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.countdown = 3
      this.timer = setInterval(() => {
        if (this.countdown <= 0) {
          clearInterval(this.timer)
          this.timer = null
          return
        }
        this.countdown--
      }, 1000)
    },
    handleBtnClick() {
      if (this.countdown > 0) return
      this.$emit('confirm')
    },
    closeActionSheet() {
      this.$emit('close')
    },
    handleActionSheetClick() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.DetailExceedTips {
  // /deep/ {
  //   .van-action-sheet {
  //     max-height: 85% !important;
  //     background-color: transparent !important;
  //     box-sizing: border-box;
  //     .van-action-sheet__content {
  //       overflow-y: initial;
  //     }
  //   }
  // }
  ::v-deep {
    .van-action-sheet {
      max-height: 85% !important;
      background-color: transparent !important;
      box-sizing: border-box;
      .van-action-sheet__content {
        overflow-y: initial;
      }
    }
  }
  .action-sheet-content {
    max-height: 85vh;
    box-sizing: border-box;
    padding-bottom: vw(60+25);
    // padding-bottom: vw(70+25);
    margin-top: vw(25);
    background: #ffffff;
    border-top-left-radius: vw(16);
    border-top-right-radius: vw(16);
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    div {
      transform: scale(1);
      transform-origin: left top;
      -webkit-text-size-adjust: 100%;
      -moz-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
      text-size-adjust: 100%;
      word-break: break-all;
      text-align: left;
    }
    .asc-top-bg-box {
      width: 100%;
      box-sizing: border-box;
      padding-bottom: vw(16);
      background: #ffa71e;
      border-radius: vw(16) vw(16) 0 0;
      text-align: left;
      .asc-text-head {
        width: 100%;
        box-sizing: border-box;
        font-size: vw(14);
        color: #fff;
        margin-top: vw(70);
        line-height: vw(20);
        padding-left: vw(30);
        padding-right: vw(24);
      }
    }
    .asc-top-mask {
      position: absolute;
      top: vw(-24);
      left: 0;
      width: 100%;
      height: vw(25);
      background: transparent;
      z-index: 1;
    }
    .asc-gt {
      width: vw(71);
      position: absolute;
      top: vw(-24);
      right: vw(30);
      z-index: 2;
    }
    .asc-top-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 0;
    }
    .asc-content {
      flex: 1;
      overflow: hidden;
      overflow-y: auto;
      width: 100%;
      box-sizing: border-box;
      padding: vw(15);
      padding-bottom: 0;
      .asc-content-A {
        padding-left: vw(15);
        font-size: vw(14);
        color: rgba($color: #050b27, $alpha: 0.8);
        line-height: vw(20);
      }
      .asc-content-B {
        width: 100%;
        box-sizing: border-box;
        margin-top: vw(8);
        padding: 0 vw(10);
        font-size: vw(24);
        color: #050b27;
        line-height: vw(33);
        position: relative;
        z-index: 1;
        text-align: center;
        .asc-content-B-row {
          width: 100%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
        }
        .asc-content-B-item::after {
          content: '';
          width: 100%;
          height: vw(8);
          background: #f6f882;
          position: absolute;
          bottom: vw(1);
          left: 0;
          z-index: -1;
        }
      }
      .asc-content-C {
        width: 100%;
        box-sizing: border-box;
        padding: 0 vw(2);
        text-align: center;
        font-weight: 600;
        font-size: vw(20);
        color: #ff2270;
        line-height: vw(28);
        margin-top: vw(10);
      }
      .asc-content-D {
        width: 100%;
        box-sizing: border-box;
        padding: vw(6) vw(2);
        // padding-left: vw(10);
        font-size: vw(12);
        color: #ff2270;
        line-height: vw(17);
        border: 1px dotted #ff2270;
        margin-top: vw(14);
      }
      .asc-content-E {
        width: 100%;
        box-sizing: border-box;
        padding: vw(14) vw(12);
        background: #f7f7f7;
        border-radius: vw(6);
        margin-top: vw(10);
        .e-title {
          font-size: vw(14);
          color: rgba($color: #050b27, $alpha: 0.8);
          font-size: vw(14);
          line-height: vw(20);
        }
        .e-item {
          display: flex;
          align-items: center;
          margin-top: vw(10);
          .e-item-icon {
            font-size: vw(20);
            margin-right: vw(7);
          }
          .e-item-text {
            font-weight: 500;
            font-size: vw(14);
            color: #050b27;
            line-height: vw(20);
          }
        }
      }
    }
    .asc-bottom-btn-wrap {
      width: 100%;
      box-sizing: border-box;
      padding-top: vw(14);
      padding-bottom: vw(10);
      display: flex;
      align-items: center;
      justify-content: center;
      .asc-bottom-btn {
        width: vw(315);
        height: vw(44);
        box-sizing: border-box;
        background: #ffffff;
        border-radius: vw(22);
        border: 1px solid #dddddd;

        display: flex;
        align-items: center;
        justify-content: center;
        font-size: vw(16);
        color: #999999;
        .btn-countdown {
          margin-left: vw(10);
        }
        &.btn-countdown-active {
          background: #ffa71e;
          color: #fff;
          border: none;
        }
      }
    }
  }
  .action-sheet-content-app {
    padding-bottom: vw(0);
    padding-bottom: calc(#{vw(0)} + constant(safe-area-inset-bottom));
    padding-bottom: calc(#{vw(0)} + env(safe-area-inset-bottom));
    // padding-bottom: vw(14+25);
    // padding-bottom: calc(#{vw(14+25)} + constant(safe-area-inset-bottom));
    // padding-bottom: calc(#{vw(14+25)} + env(safe-area-inset-bottom));
  }
  .action-sheet-content-red {
    .asc-top-bg-box {
      background: #ff2270 !important;
    }
    .asc-content-B-item::after {
      background: #ffdde9 !important;
    }
    .btn-countdown-active {
      background: #ff2270 !important;
    }
  }
}
</style>
